import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard — renders its children only for accounts holding `permission`,
 * otherwise redirects home. Preferred over RequireAdmin for anything a
 * non-administrator may legitimately reach: the same permission that lets the
 * navigation link show (declared in the providing module's navigation.yml) is
 * the one checked here, so a visible link is never a dead end.
 *
 * AuthGuard has resolved the user by the time routes render, so the permission
 * list is reliable here.
 */
export default function RequirePermission({ permission, children }) {
  const { isAdmin, hasPermission } = useAuth();
  // The administrator role is `is_admin` in Drupal, so it holds every
  // permission by definition — including one whose providing module happens to
  // be disabled on this instance, which /api/user/info cannot enumerate.
  if (!isAdmin && !hasPermission(permission)) return <Navigate to="/" replace />;
  return children;
}
